module.exports = __webpack_public_path__ + "static/media/mistake.80941061.svg";